import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import {
  querySupplierList,
  updateSupplier,
  deleteSupplier,
} from "@/api/supplier";

export default function useSupplierTable() {
  // 搜索条件refS
  const searchRef = ref(null);

  // 新增编辑ref
  const adjustRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    name: null,
    contact: null,
    mobile: null,
    type: null,
  });

  // 表格loading
  const tableLoading = ref(false);

  // 表格列配置
  const columns = ref([
    {
      label: "供应商编号",
      prop: "number",
    },
    {
      label: "供应商名称",
      prop: "name",
    },
    {
      label: "合作开始日期",
      prop: "startTime",
    },
    {
      label: "合作结束日期",
      prop: "endTime",
    },
    {
      label: "联系人",
      prop: "contact",
    },
    {
      label: "联系电话",
      prop: "mobile",
    },
    {
      label: "状态",
      prop: "status",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 分页数据
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    querySupplierList({
      ...searchData,
      page: pages.page,
      limit: pages.size,
    })
      .then((res) => {
        tableData.value = res.data.records || [];
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    pages.page = 1;
    getList();
  };

  // 点击编辑
  const handleAdjust = (row, type) => {
    adjustRef.value?.handleDialogOpen({ row, type });
  };

  // 点击删除
  const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除供应商【${row.name}】吗？`, "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteSupplier(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  // 点击禁用
  const handleDisabled = (row) => {
    ElMessageBox.confirm(`确定更改供应商【${row.name}】的状态吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const status = row.status.value == "1" ? "2" : "1";
        updateSupplier({
          id: row.id,
          status,
        }).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  return {
    searchRef,
    adjustRef,
    searchData,
    tableLoading,
    columns,
    tableData,
    pages,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    handleAdjust,
    handleDelete,
    handleDisabled,
  };
}
